"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseJSON = exports.appendFallbackUrlProtocol = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var guid_1 = require("../../utils/guid");
var appendFallbackUrlProtocol = function (url) {
    var hasProtocol = (0, lodash_1.some)(['http://', 'https://'], function (protocol) {
        return (0, lodash_1.startsWith)(url, protocol);
    });
    return hasProtocol ? url : "https://".concat(url);
};
exports.appendFallbackUrlProtocol = appendFallbackUrlProtocol;
var trimStrings = function (rawCard) {
    return (0, lodash_1.reduce)(rawCard, function (result, value, key) {
        if ((0, lodash_1.isString)(value)) {
            result[key] = value.trim();
            return result;
        }
        result[key] = value;
        return result;
    }, {});
};
var parseJSON = function (rawCard) {
    rawCard = trimStrings(rawCard);
    if (rawCard.url) {
        rawCard.url = (0, exports.appendFallbackUrlProtocol)(rawCard.url);
    }
    return tslib_1.__assign(tslib_1.__assign({}, rawCard), { clientId: rawCard.clientId || (0, guid_1.guid)(), updatedTimestamp: rawCard.updatedTimestamp || Date.now() });
};
exports.parseJSON = parseJSON;
//# sourceMappingURL=parse-json.js.map